<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <div class='flex-sb'>
          <el-link icon='el-icon-back' @click='handleBack'>返回</el-link>
          <ImageShare :btn-title='`分享详情`' :dialog-title='`分成详情分享图`' :share-content-id='`shareContent`'
                      @dialogImageVisible='dialogImageVisible' />
        </div>

        <div id='shareContent'>
          <div v-show='!showBtn'>&nbsp;&nbsp;&nbsp;&nbsp;</div>
          <div class='invoice-notice' v-show='!showBtn'>
            红人在支付宝自行代开发票或自己开公司的，开票金额都是：应付款合计
          </div>
          <div class='theme-border default-box'>
            <div class='commission-header'>
              <h2 class='commission-title'>红人分成详情</h2>
            </div>
            <el-main>
              <div class='default-table'>
                <el-form :model='formData' label-suffix='：' inline>
                  <el-row>
                    <el-col :span='6'>
                      <el-form-item label='月份'>
                        <span>{{ dateFormat(formData.date_time, '{y}年{m}月') }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='红人昵称'>
                        {{ formData.nickname }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='卖货分成' title='电商应付款'>
                        {{ moneyFormat(formData.commerce_pay) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='推广分成' title='推广应付额'>
                        {{ moneyFormat(formData.publicity_pay) }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span='6'>
                      <el-form-item label='佣金分成' title='佣金应付款'>
                        {{ moneyFormat(formData.brokerage_pay) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='其他应扣/补款' title='其他应扣/补款'>
                        {{ moneyFormat(formData.other_pay) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='承担的营销费用'>
                        {{ moneyFormat(formData.marketing_costs) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='应付款合计'>
                        {{ moneyFormat(formData.due_total) }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span='6'>
                      <el-form-item label='个税'>
                        {{ moneyFormat(formData.person_tax) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='实付款'>
                        {{ moneyFormat(formData.actual_pay) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='扣（补款）备注'>
                        {{ formData.deduct_remark || '--' }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='结算方式'>
                        {{ formData.settle_method_text || formData.settle_method }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-show='showBtn'>
                    <el-col :span='6'>
                      <el-form-item label='发票'>
                        {{ formData.need_invoice_text || formData.need_invoice }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='申请付款时间'>
                        {{ formData.apply_time || '--' }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='发放时间'>
                        {{ formData.payment_time }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='6'>
                      <el-form-item label='备注'>
                        {{ formData.remark || '' }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>

              <div class='remarks_button' v-show='showBtn'>
                注：红人在支付宝自行代开发票或自己开公司的，开票金额都是：<span>应付款合计</span>
                <div class='item_button'>
                  <el-button @click='handleEdit(formData)' size='medium' type='primary'
                             v-if="userPermissions.indexOf('artist_divide_save') !== -1 && (formData.audit === 1 || formData.audit === 3)">
                    修改
                  </el-button>
                </div>
              </div>
            </el-main>
          </div>
          <el-divider />
          <div class='theme-border default-box order-detail-box'>
            <div class='flex-sb'>
              <div class='order-detail-panel'>
                <div class='order-detail-header'>
                  <h2 class='order-detail-title' @click='getDetail'>订单明细（共 {{ orderTableData.length }}
                    条，合计：{{ moneyFormat(totalExecPrice) }} 元）</h2>
                  <div>
                    <!--                    <el-button v-show='showBtn' v-if='formData.audit === 1' type='primary' icon='el-icon-plus'-->
                    <!--                               @click='handleAddOrderData'>-->
                    <!--                      添加-->
                    <!--                    </el-button>-->
                    <el-button v-if="userPermissions.indexOf('artist_divide_sync') !== -1"
                               title='查看订单明细来源（可重新同步）' type='text' v-show='showBtn'
                               @click='showOrderSource' icon='el-icon-link'></el-button>
                  </div>
                </div>
                <div class='order-detail-content'>
                  <div class='table-container'>
                    <el-table :border='true' :data='orderTableData' :header-cell-style='headClass'
                              class="w-full h-full" :sum-text="showBtn ? '合计' : 'x'"
                              :summary-method='getSummaries' @selection-change='handleSelectionChange'
                              :show-summary='showBtn'
                              tooltip-effect='dark'>
                      <el-table-column align='center' label='序号' width='60' class-name='table-cell'>
                        <template slot-scope='scope'>
                          <span>{{ scope.$index + 1 }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column align='center' label='红人昵称' prop='nickname' class-name='table-cell'
                                       width='140' />
                      <!--                      <el-table-column align='center' label='订单编号' prop='order_no' width='160' show-overflow-tooltip />-->
                      <!--                      <el-table-column align='center' label='经纪人' prop='agent_name' class-name='table-cell' />-->
                      <el-table-column align='center' label='类别' prop='type' class-name='table-cell' width='100'>
                        <template slot-scope='{row}'>{{ row.type_text || '' }}</template>
                      </el-table-column>
                      <el-table-column align='center' label='执行时间' prop='exec_date' class-name='table-cell'
                                       width='120' />
                      <el-table-column align='center' label='品牌' prop='brand' class-name='table-cell' />
                      <el-table-column align='center' label='产品' prop='product' class-name='table-cell' />
                      <el-table-column prop="platforms" align='center' label='发布平台'/>
                      <el-table-column prop="content_forms" align='center' label='内容形式'/>
                      <el-table-column align='right' label='可分配收入' prop='exec_price' class-name='table-cell-price'>
                        <template slot-scope='{ row }'>
                          <span>{{ moneyFormat(row.exec_price) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column align='right' label='分成比例'>
                        <template v-slot="{row:{rate}}">
                          <span>{{ rate|numberFormat }}%</span>
                        </template>
                      </el-table-column>
                      <el-table-column align='right' label='红人分成' prop='artist_income'>
                        <template v-slot="{row:{artist_income}}">
                          <span>{{ artist_income|moneyFormat }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column align='center' label='操作' width='100'
                                       v-if="showBtn&&userPermissions.indexOf('artist_order_delete') !== -1"
                                       class-name='table-cell-action'>
                        <template slot-scope='{ row }'>
                          <el-link class='action-link' @click='handleRemove(row)'>
                            <i class='el-icon-close' />
                          </el-link>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <br />
        <div v-show='showBtn' style='padding: 10px 10px'>
          <div class='default-box theme-border'>
            <div class='flex-sb' style='padding: 10px 20px'>
              <h2 @click='getDetail'>打款凭据</h2>
              <div>
                <el-button type='success' icon='el-icon-s-promotion'
                           v-if='userPermissions.indexOf("artist_divide_save")>-1'
                           @click='handleNotify'>
                  通知
                </el-button>
                <el-button type='primary' icon='el-icon-upload'
                           v-if='userPermissions.indexOf("artist_divide_save")>-1'
                           @click='handleAddUploadVoucher'>
                  {{ formData.voucher_id > 0 ? '重新上传' : '上传' }}
                </el-button>
                <el-button type='danger' plain icon='el-icon-close'
                           v-if='userPermissions.indexOf("artist_divide_save")>-1 && formData.voucher_id>0'
                           @click='handleDeleteVoucher'>
                  撤回
                </el-button>
              </div>
            </div>
            <div class='theme-border'>
              <div class='default-block'>
                <div class='payment-time'>
                  打款凭据上传时间：{{ voucherData.created_at || '--' }}
                  &nbsp; &nbsp; | &nbsp; &nbsp;
                  发放时间：{{ formData.payment_time || '--' }}
                </div>
                <div class='photo-frame' v-if='voucherData &&voucherData.full_path'>
                  <el-image style='min-width: 585px; min-height: 235px;max-width: 1200px;' :src='voucherData.full_path'
                            :preview-src-list='[voucherData.full_path]' lazy>
                    <div slot='placeholder' class='image-slot'>
                      加载中<span class='dot'>...</span>
                    </div>
                    <div slot='error' class='image-slot'>
                      <i class='el-icon-picture-outline'></i>
                    </div>
                  </el-image>
                </div>
                <div v-else
                     style='height: 200px;width: 400px;margin: auto;display: flex;justify-content: center;align-items: center '
                     class='theme-border'>
                  <span style='font-size: 16px;color: #E6A23C'>
                    未上传凭据
                    <el-link type='text'
                             v-if='userPermissions.indexOf("artist_divide_save")>-1'
                             @click='handleAddUploadVoucher'>点击上传</el-link>
                  </span>
                </div>

              </div>
            </div>

            <!--            打款凭据附件（图片/PDF/Word/Excel 等，支持多个）-->
            <div class='theme-border attachment-box'>
              <UploadAttachment :divide-id='id' :attachments='divideAttachments' @saved='getDetail' />
            </div>

            <!--            <div style='display: flex;justify-content: center;gap: 10px;padding: 10px'>-->
            <!--              <el-button type='primary' icon='el-icon-s-promotion'-->
            <!--                         v-if='userPermissions.indexOf("artist_divide_save")>-1'-->
            <!--                         @click='handleNotify'>-->
            <!--                通知-->
            <!--              </el-button>-->
            <!--              <el-button type='primary' icon='el-icon-upload'-->
            <!--                         v-if='userPermissions.indexOf("artist_divide_save")>-1'-->
            <!--                         @click='handleAddUploadVoucher'>-->
            <!--                {{ formData.voucher_id > 0 ? '重新上传' : '上传' }}-->
            <!--              </el-button>-->
            <!--              <el-button type='danger' plain icon='el-icon-close'-->
            <!--                         v-if='userPermissions.indexOf("artist_divide_save")>-1 && formData.voucher_id>0'-->
            <!--                         @click='handleDeleteVoucher'>-->
            <!--                撤回-->
            <!--              </el-button>-->
            <!--            </div>-->
          </div>
          <br />
        </div>
        <br />
        <div v-show='showBtn' class='log-panel'>
          <div class='log-panel-header flex-sb'>
            <div>
              操作记录
            </div>
            <el-button type='text' :icon='!showLog?"el-icon-caret-bottom":"el-icon-caret-top"'
                       @click='showLog=!showLog'>
              {{ !showLog ? '展开' : '隐藏' }}
            </el-button>
          </div>
          <div class='log-content'>
            <LogList :divide-id='id' v-if='id && showLog' />
          </div>
        </div>
        <br />
        <br />
      </div>
    </PageHeaderLayout>

    <!-- 新增佣金分成弹窗 -->
    <CreateEdit ref='refCreateEdit' @saved='getDetail' />

    <!--    添加订单明细-->
    <CreateArtistOrder ref='refCreateArtistOrder' @saved='getDetail' />
    <!--    上传打款凭证-->
    <UploadVoucher ref='refUploadVoucher' @saved='getDetail' />
    <!--    通知打开凭据已上传-->
    <NotifySend ref='refNotifySend'></NotifySend>

    <OrderSourcePanel ref='refOrderSourcePanel' @synced='getDetail'></OrderSourcePanel>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import { mapGetters } from 'vuex'
import DingTalkDeptSelect from '@/pages/departments/components/DingTalkDeptSelect'
import NotifyTaskList from '@/pages/lb/NotifyTaskList'
import DingTalkNotify from '@/components/dingTalkNotify/index'
import LogList from '@/pages/artist_commission/components/LogList'
import CreateEdit from '@/pages/artist_commission/components/CreateEdit.vue'
import CreateArtistOrder from '@/pages/artist_commission/components/CreateArtistOrder.vue'
import { parseTime } from '@/utils'
import UploadVoucher from '@/pages/artist_commission/components/UploadVoucher.vue'
import UploadAttachment from '@/pages/artist_commission/components/UploadAttachment.vue'
import NotifySend from '@/pages/artist_commission/components/NotifySend.vue'
import OrderSourcePanel from '@/pages/artist_commission/components/OrderSourcePanel.vue'

export default {
  name: 'CommissionDetail',
  components: {
    OrderSourcePanel,
    NotifySend,
    UploadVoucher,
    UploadAttachment,
    CreateArtistOrder,
    CreateEdit,
    PageHeaderLayout,
    DingTalkDeptSelect,
    NotifyTaskList,
    DingTalkNotify,
    LogList
  },
  computed: {
    ...mapGetters(['userPermissions']),
    totalExecPrice() {
      if (this.orderTableData && this.orderTableData.length > 0)
        return this.orderTableData.reduce((acc, obj) => acc + obj.exec_price / 1, 0)
      else
        return 0
    }
  },
  data() {
    return {
      id: null,
      formData: {},
      voucherData: { full_path: '' },//打款凭据数据
      divideAttachments: [],//打款凭据附件列表
      // src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      orderTableData: [],
      selection: [],
      drawer: false,
      isIndeterminate: true,
      checkAll: false,
      checkedMembers: [],
      loadingNotify: false,
      showTaskList: false,
      showBtn: true,
      showLog: false
    }
  },
  watch: {},
  methods: {
    handleEdit(row) {
      if (this.$refs.refCreateEdit) {
        this.$refs.refCreateEdit.edit(row)
      }
    },

    // 批量样式居中
    headClass() {
      return 'text-align:center'
    },

    noticeClick() {
      this.$confirm('是否立即通知财务', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const postData = {
          id: this.$route.params.id,
          type: 'finance',
          rec_user_ids: [this.formData.user_id]
        }
        const info = await this.$api.dingTalkNotifyartistDivide(postData)
        if (info) {
          this.msgSuccess('成功！')
        } else {
          this.$notify.error('未知错误')
        }
      }).catch(() => {
        this.$notify.info('已取消通知')
      })
    },

    handleSelectionChange(val) {
      this.selection = val
    },

    async handleRemove(row) {
      this.$confirm('确认删除此订单明细？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const info = await this.$api.delOrder([row.id])
        if (info) {
          this.$notify.success('删除成功')
        }
        await this.getDetail()
      }).catch(() => {
        this.$notify.info('已取消')
      })
    },

    moneyFormat(value) {
      return this.$utils.numberFormat(value, 2, '.', ',', 'round')
    },

    async getDetail() {
      const { divide_detail, order_detail, divide_voucher, divide_attachments } = await this.$api.getArtistDivide(this.id)
      this.$nextTick(() => {
        this.formData = { ...divide_detail }
        this.voucherData = { ...divide_voucher }
        this.divideAttachments = divide_attachments || []
        this.orderTableData = order_detail || []
      })
    },

    dialogImageVisible(val) {
      this.showBtn = val
    },
    calcSummaries(param, sumColProps) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (sumColProps.indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          sums[index] = this.moneyFormat(sums[index])
        }
      })

      return sums
    },
    getSummaries(param) {
      return this.calcSummaries(param, ['exec_price', 'artist_income'])
      // const { columns, data } = param
      // const sums = []
      // if (data && data.length > 0) {
      //   sums.push('合计')
      //   let actualPay = 0
      //   data.forEach(({ exec_price }) => {
      //     actualPay += Number(exec_price)
      //   })
      //
      //   // 动态计算执行价列的位置
      //   // 基础列：序号(0)、红人昵称(1)、执行时间(2)、品牌(3)、产品(4)
      //   // 执行价列位置：5（如果显示执行价列）
      //   // 操作列位置：6（如果显示操作列）
      //   let execPriceColumnIndex = 5
      //
      //   for (let i = 1; i <= columns.length - 1; i++) {
      //     if (i === execPriceColumnIndex) {
      //       sums.push(this.moneyFormat(actualPay))
      //     } else {
      //       sums.push('')
      //     }
      //   }
      // }
      // return sums
    },

    handleAddOrderData() {
      if (this.$refs.refCreateArtistOrder) {
        this.$refs.refCreateArtistOrder.add(this.formData)
      }
    },
    //添加打款凭证
    handleAddUploadVoucher() {
      if (this.$refs['refUploadVoucher']) {
        this.$refs['refUploadVoucher'].add(this.formData)
      }
    },
    handleDeleteVoucher() {
      this.$confirm('确认【撤回】此打款凭据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const info = await this.$api.deleteArtistDivideVoucher(this.formData.id)
        if (info) {
          this.$notify.success('撤回成功')
        }
        await this.getDetail()
      }).catch(() => {
        this.$notify.info('已取消')
      })
    },
    handleBack() {
      this.$router.go(-1)
    },

    dateFormat(dateStr, cFormat) {
      return parseTime(dateStr, cFormat || '{y}-{m}-{d}')
    },
    handleNotify() {
      if (this.$refs['refNotifySend'])
        this.$refs['refNotifySend'].open(this.formData)
    },
    showOrderSource() {
      //
      if (this.$refs['refOrderSourcePanel'])
        this.$refs['refOrderSourcePanel'].open(this.formData)
    }
  },
  created() {
    this.id = this.$route.params.id
    if (this.id)
      this.getDetail()
    else
      this.handleBack()
  },
  mounted() {
    this.showLog = false
    // setTimeout(() => {
    //   this.showLog = true
    // }, 1500)
  }
}
</script>

<style lang='scss' scoped>
#shareContent {
  overflow: hidden;
}

.invoice-notice {
  margin: 10px auto;
  font-weight: bold;
  text-align: center;
  font-size: 20px;
}

.order-detail-container {
  gap: 20px;
  align-items: stretch;
  margin-bottom: 30px;
  flex-wrap: wrap;
  height: 300px;
}

.order-detail-box {
  margin-bottom: 50px;
}

.order-detail-panel {
  min-width: 780px;
  padding: 15px;
  background: #ffffff;
  border-radius: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.log-panel {
  min-width: 580px;
  padding: 15px;
  background: #ffffff;
  border-radius: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.order-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
}

.commission-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
}

.commission-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.order-detail-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  cursor: pointer;
  transition: color 0.3s ease;
}

.order-detail-title:hover {
  color: #409EFF;
}

.order-detail-content {
  overflow-x: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.log-panel-header {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
}

.table-container {
  //border-radius: 6px;
  overflow: hidden;
  //border: 1px solid #ebeef5;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.log-content {
  flex: 1;
  overflow-y: auto;
  min-height: 200px;
}

.table-header {
  background: #f5f7fa;
  font-weight: 600;
  color: #606266;
}

.table-cell {
  padding: 12px 8px;
  font-size: 14px;
  color: #606266;
}

.table-cell-price {
  text-align: right;
  font-weight: 500;
  color: #67C23A;
}

.table-cell-action {
  text-align: center;
}

.action-link {
  color: #F56C6C;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.action-link:hover {
  color: #F78989;
}

.table-footer {
  background: #f5f7fa;
  font-weight: 600;
  color: #303133;
}

.notify-button {
  background-color: #409EFF;
  border: 0;
}

.opt-panel {
  position: fixed;
  bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 98%;
  border: #f2f2f2 1px dashed;
  border-radius: 10px;
  padding: 10px;
  opacity: 80%;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 1000;
}

.default-box {
  padding: 10px;

  .default-block {
    width: 100%;
    min-height: 280px;
    text-align: center;
    vertical-align: middle;
  }

  .payment-time {
    padding: 10px 20px;
    font-size: 14px;
    margin: auto;
  }

  .photo-frame {
    width: clamp(400px, 90%, 1280px);
    min-height: 270px;
    margin: auto;
  }
}

.remarks_button {
  margin: 20px 0;

  > span {
    color: red;
  }

  .item_button {
    margin-right: 10px;
    margin-top: 6px;
    text-align: right;
  }
}

.form {
  width: 500px;
  margin: 10% auto;
}

.dept-member {
  width: 90%;
  border: #DCDFE6 1px solid;
  min-height: 500px;
  margin: 0 auto;
}

.notify-dept {
  width: 500px;
  border: #DCDFE6 1px solid;
  padding: 10px;
  overflow-y: scroll;
}

.all_box {
  margin-left: 90px;
  float: left;
}

.check-all {
  height: 20px;
  padding: 5px;
  margin-bottom: 5px;
}

.member-list {
  > div > label {
    display: block;
    width: 180px;
    margin: 10px;
    padding: 0;
  }
}

.button_box {
  text-align: center;

  > .notify-record {
    margin-top: 10px;
    padding: 10px;
    max-height: 200px;
    overflow-y: scroll;
  }
}

.minfrom {
  > .form {
    width: auto;
  }

  display: none;
}

@media screen and (max-width: 1200px) {
  .order-detail-container {
    flex-direction: column;
    gap: 15px;
  }

  .order-detail-panel,
  .log-panel {
    min-width: 100%;
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .order-detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .order-detail-title {
    font-size: 16px;
  }

  .table-container {
    overflow-x: auto;
  }

  .order-detail-content {
    overflow-x: auto;
  }

  .log-panel-header {
    font-size: 16px;
  }
}

@media screen and (max-width: 600px) {
  .minfrom {
    display: block;
    margin-left: 10px;

    > form {
      margin: 0;

      > .el-form-item {
        line-height: 10px !important;
        margin: 4px auto;
        overflow: scroll;
      }
    }
  }

  .mintable {
    display: none;
  }

  .order-detail-panel,
  .log-panel {
    padding: 10px;
  }

  .table-cell {
    padding: 8px 6px;
    font-size: 12px;
  }

  .action-link {
    font-size: 14px;
  }

  .opt-panel {
    flex-direction: column;
    gap: 8px;
    padding: 8px;
  }
}
</style>
